import { Button, Modal } from "react-bootstrap";
import PropTypes from "prop-types";

const LwcModal = ({
	cancelButton,
	children,
	className,
	handleClose,
	handleModalSubmit,
	show,
	submitButtonText,
	title
}) => (
	<Modal className={className} onHide={handleClose} show={show} >
		<Modal.Header className="px-4 py-3" closeButton>
			<Modal.Title className="text-neutral4 fs-18 fw-bold">
				{title}
			</Modal.Title>
		</Modal.Header>

		<Modal.Body className="p-4">
			{children}
		</Modal.Body>

		<Modal.Footer>
			{
				cancelButton ? (
					<Button className="bg-neutral4 border-0" onClick={handleClose} variant="secondary">
						Cancel
					</Button>
				) : null
			}

			<Button className="bg-blue border-0" onClick={handleModalSubmit} variant="primary">
				{submitButtonText}
			</Button>
		</Modal.Footer>
	</Modal>
);

LwcModal.propTypes = {
	cancelButton: PropTypes.bool,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	handleClose: PropTypes.func.isRequired,
	handleModalSubmit: PropTypes.func.isRequired,
	show: PropTypes.bool.isRequired,
	submitButtonText: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired
};

LwcModal.defaultProps = {
	cancelButton: true,
	className: ""
};

export default LwcModal;
